export default "__VITE_ASSET__D_ibk$_a__"